module.exports = __webpack_public_path__ + "static/media/portfolio-02.dbd5dc4a.jpg";